import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useContext } from 'react';
import styled from 'styled-components';
import { Button } from '@clds/button-old';
import { Cross } from '@clds/icon';
import { InternalModalContext } from '../../context.js';
import { modalLayoutTheme } from '../theme.js';
const StyledButton = styled(Button) `
  margin-left: ${modalLayoutTheme.layout.spacing.horizontal};
  transform: translate(${(props) => props.theme.spacing.xs}, -50%);
  border: none;
`;
const IconWrapper = styled.div `
  height: 0;
`;
export const ModalCloseIcon = ({ className }) => {
    const { onClose } = useContext(InternalModalContext);
    const handleOnClose = useCallback((event) => onClose?.(event, 'header-close-button'), [onClose]);
    return (_jsx(IconWrapper, { onClick: handleOnClose, children: _jsx(StyledButton, { className: className, "data-testid": "header-close-button", "data-test-specifier": "modal-close-icon", size: "md", variant: "secondary", tone: "plain", leftSlot: _jsx(Cross, { size: "md" }) }) }));
};
